/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import './custom-types';

import { BrowserRouter, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Loading } from 'carbon-addons-iot-react';
import { QueryParamProvider } from 'use-query-params';
import { PersistGate } from 'redux-persist/integration/react';
import { HelmetProvider } from 'react-helmet-async';

import travisEnvironment from '../image/travisEnvironment';

import { store, persistor } from './store';

import { PropsRoute } from 'Common';
import HomeApp from 'HomeApp';

const render = () => {
  ReactDOM.render(
    <Provider store={store}>
      <PersistGate loading={<Loading />} persistor={persistor}>
        <BrowserRouter>
          <Suspense fallback={<Loading />}>
            <QueryParamProvider ReactRouterRoute={Route}>
              <HelmetProvider>
                <PropsRoute path="/" component={HomeApp} />
              </HelmetProvider>
            </QueryParamProvider>
          </Suspense>
        </BrowserRouter>
      </PersistGate>
    </Provider>,
    document.getElementById('mount')
  );
};
if (travisEnvironment?.commit !== 'travisDevCommit') {
  // this is a real build, need to log this for servicability reasons
  console.log('Current build level is: ', travisEnvironment); // eslint-disable-line no-console
}
render();

if (module.hot) {
  module.hot.accept();
}
